import React from "react";
import moment from "moment";

import { connect } from "react-redux";

import { UserIcon } from "components";
import { dateFormat } from "utils";

export const MessageGroup = (props) => {
  const { from, messages, date, currentUser } = props;

  return (
    <div className={`message-item ${from.id === currentUser.id ? "personnal" : ""}`}>
      <UserIcon link user={from} />
      <div className="content-wrap">
        <small>
          <span className="name">{`${from.name} ${from.surname}`}</span>
          <span className="date">{moment(date).format(`${dateFormat} HH:mm`)}</span>
        </small>
        {messages.map((m, i) => (
          <p key={i} className="message-bubble">
            {m}
          </p>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(MessageGroup);
